var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("flexbox", { staticClass: "xr-import" }, [
    _vm.loading
      ? _c("div", {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "xr-import__icon",
        })
      : _c("i", { staticClass: "wk wk-success xr-import__icon" }),
    _vm._v(" "),
    _c(
      "p",
      { staticClass: "xr-import__label", class: { "is-loading": _vm.loading } },
      [_vm._v(_vm._s(_vm.processLabel))]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }